import { BCMSAsset } from "@bcm-dev/bcms-vite";

// Import SVGs
import AlertTriangleIcon from "res/img/alert-triangle-icon.svg?react";
import AutoPayIcon from "res/img/auto-pay-icon.svg?react";
import BellIcon from "res/img/bell-icon.svg?react";
import BuildingIcon from "res/img/building-icon.svg?react";
import CalendarIcon from "res/img/calendar-icon.svg?react";
import CheckmarkIcon from "res/img/checkmark-icon.svg?react";
import CheckmarkOutlineIcon from "res/img/checkmark-outline-icon.svg?react";
import CirclePlusSignIcon from "res/img/circle-plus-sign-icon.svg?react";
import ClockNotebookIcon from "res/img/ClockNotebookIcon.svg?react";
import CloseIcon from "res/img/close-icon.svg?react";
import DocumentIcon from "res/img/DocumentIcon.svg?react";
import DownChevronIcon from "res/img/down-chevron-icon.svg?react";
import DownloadIcon from "res/img/DownloadIcon.svg?react";
import EbillsIcon from "res/img/ebills-icon.svg?react";
import EditIcon from "res/img/edit-icon.svg?react";
import ExclamationPointIcon from "res/img/exclamation-point-icon.svg?react";
import EyeIcon from "res/img/EyeIcon.svg?react";
import FilterLinesIcon from "res/img/FilterLinesIcon.svg?react";
import GearIcon from "res/img/gear-icon.svg?react";
import InfoIcon from "res/img/InfoIcon.svg?react";
import LaptopIcon from "res/img/LaptopIcon.svg?react";
import LeftChevronIcon from "res/img/left-chevron-icon.svg?react";
import LetterIcon from "res/img/letter-icon.svg?react";
import LightBulbIcon from "res/img/lightbulb-icon.svg?react";
import ListPencilIcon from "res/img/ListPencilIcon.svg?react";
import MagnifyingGlassIcon from "res/img/magnifying-glass-icon.svg?react";
import MessagesIcon from "res/img/MessagesIcon.svg?react";
import PayIcon from "res/img/pay-icon.svg?react";
import PlusSign from "res/img/plus-sign.svg?react";
import PrinterIcon from "res/img/PrinterIcon.svg?react";
import QuestionCircleOutlineIcon from "res/img/QuestionCircleOutlineIcon.svg?react";
import QuestionMarkIcon from "res/img/QuestionMarkIcon.svg?react";
import RightChevronIcon from "res/img/right-chevron-icon.svg?react";
import RightArrowIcon from "res/img/RightArrowIcon.svg?react";
import SaveIcon from "res/img/save-icon.svg?react";
import StatusIndicatorCircleIcon from "res/img/status-indicator-circle-icon.svg?react";
import TrashCanIcon from "res/img/trash-can-icon.svg?react";
import TwoArrowsIcon from "res/img/two-arrows-icon.svg?react";
import UpsellIcon from "res/img/upsell-icon.svg?react";
import WalletIcon from "res/img/WalletIcon.svg?react";
import XIcon from "res/img/x-icon.svg?react";
import XOutlineIcon from "res/img/x-outline-icon.svg?react";
import ZelleLogo from "res/img/zelle-logo.svg?react";

// Import Images
import BillTemplateImage from "res/img/bill-template.png";
import CompanyBillerImage from "res/img/company-biller-icon.png";
import GeneralLendersLogo from "res/img/credit-card-logo.png";
import FederalElectricLogo from "res/img/federalElectricLogo.png";
import FirstCreditServices from "res/img/first-credit-services.png";
import GiveGoodLogo from "res/img/GiveGood.png";
import MyMobileServicesLogo from "res/img/life-insurance-spiral-logo.png";
import FastAutoLogo from "res/img/maroon-gauge-logo.png";
import MobileUltraLogo from "res/img/mobile-ultra-logo.png";
import MyMortgageLogo from "res/img/mortgage-1.png";
import MyFinancialLogo from "res/img/myFinancialLogo-white.png";
import NationalCreditIconLogoGraph from "res/img/national-credit-icon-logo-graph.png";
import OrangeFinancialLogo from "res/img/orange-financial-logo.png";
import PersonBillerImage from "res/img/person-biller-icon.png";
import SuperFinancialLogo from "res/img/super-financial-logo-grey.png";
import TelecomSquareLogo from "res/img/telecom-square-logo.png";

const { image, svg } = BCMSAsset.init({
    // Add SVGs here
    "AlertTriangleIcon" : AlertTriangleIcon,
    "AutoPayIcon": AutoPayIcon,
    "BellIcon":BellIcon,
    "BuildingIcon": BuildingIcon,
    "CalendarIcon": CalendarIcon,
    "CheckmarkIcon": CheckmarkIcon,
    "CheckmarkOutlineIcon": CheckmarkOutlineIcon,
    "CirclePlusSignIcon": CirclePlusSignIcon,
    "ClockNotebookIcon": ClockNotebookIcon,
    "CloseIcon": CloseIcon,
    "DocumentIcon": DocumentIcon,
    "DownChevronIcon": DownChevronIcon,
    "DownloadIcon": DownloadIcon,
    "EbillsIcon": EbillsIcon,
    "EditIcon": EditIcon,
    "ExclamationPointIcon": ExclamationPointIcon,
    "EyeIcon": EyeIcon,
    "FilterLinesIcon": FilterLinesIcon,
    "GearIcon": GearIcon,
    "InfoIcon": InfoIcon,
    "LaptopIcon": LaptopIcon,
    "LeftChevronIcon": LeftChevronIcon,
    "LetterIcon": LetterIcon,
    "LightBulbIcon": LightBulbIcon,
    "ListPencilIcon": ListPencilIcon,
    "MagnifyingGlassIcon": MagnifyingGlassIcon,
    "MessagesIcon": MessagesIcon,
    "PayIcon": PayIcon,
    "PlusSign": PlusSign,
    "PrinterIcon": PrinterIcon,
	"QuestionCircleOutlineIcon": QuestionCircleOutlineIcon,
    "QuestionMarkIcon": QuestionMarkIcon,
    "RightArrowIcon": RightArrowIcon,
    "RightChevronIcon": RightChevronIcon,
    "SaveIcon": SaveIcon,
    "StatusIndicatorCircleIcon": StatusIndicatorCircleIcon,
    "TrashCanIcon": TrashCanIcon,
    "TwoArrowsIcon": TwoArrowsIcon,
    "UpsellIcon": UpsellIcon,
    "XIcon": XIcon,
    "XOutlineIcon": XOutlineIcon,
    // Zelle Icon is 100 x 50 to accomodate the navigation height
    "ZelleLogo": ZelleLogo,
    "WalletIcon": WalletIcon,
    
	

    // Add Images here
    "BillTemplateImage": BillTemplateImage,
    "CompanyBillerImage": CompanyBillerImage,
    "GiveGoodLogo": GiveGoodLogo,
    "PersonBillerImage":  PersonBillerImage,
    "FederalElectricLogo": FederalElectricLogo,
    "MobileUltraLogo": MobileUltraLogo,
    "NationalCreditIconLogoGraph": NationalCreditIconLogoGraph,
    "OrangeFinancialLogo": OrangeFinancialLogo,
    "TelecomSquareLogo": TelecomSquareLogo,
    "MyMortgageLogo" :MyMortgageLogo,
    "GeneralLendersLogo" :GeneralLendersLogo,
    "MyMobileServicesLogo":MyMobileServicesLogo,
    "FastAutoLogo" :FastAutoLogo,
    "SuperFinancialLogo" :SuperFinancialLogo,
    "MyFinancialLogo": MyFinancialLogo,
    "FirstCreditServices": FirstCreditServices
}).loadAsset();

// Return a function for images
export function ImageAsset(props) {
    return (<> { image(props.id, props) } </>);
}

// Return a function for svgs
export function SVGAsset(props) {
    return (<> { svg(props.id, { ...props, className: `${ props.className ?? "" } icon` }) } </>);
}